import CloseIcon from '@mui/icons-material/Close';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ConfirmationModalProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
	title: string;
	message: string;
	confirmButtonText?: string;
	cancelButtonText?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
	open,
	onClose,
	onConfirm,
	title,
	message,
	confirmButtonText,
	cancelButtonText,
}) => {
	const { t } = useTranslation();

	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="confirmation-dialog-title"
			aria-describedby="confirmation-dialog-description"
			PaperProps={{
				sx: {
					width: '500px',
					borderRadius: '12px',
					padding: '24px',
				},
			}}
		>
			<div className="flex justify-between items-center mb-6">
				<DialogTitle
					id="confirmation-dialog-title"
					sx={{
						padding: 0,
						fontFamily: 'Roboto',
						fontSize: '20px',
						fontWeight: 700,
						lineHeight: '140%',
						color: '#343A40',
					}}
				>
					{title}
				</DialogTitle>
				<IconButton
					aria-label="close"
					onClick={onClose}
					sx={{
						padding: 0,
						color: '#7B809A',
						'&:hover': {
							backgroundColor: 'transparent',
							color: '#343A40',
						},
					}}
				>
					<CloseIcon />
				</IconButton>
			</div>
			<div className="w-full h-[2px] bg-[#E9ECEF] mb-6" />
			<DialogContent sx={{ padding: 0 }}>
				<div className="py-4">
					<Typography
						className="text-secondary roboto-regular"
						sx={{
							fontSize: '16px',
							lineHeight: '140%',
							textAlign: 'center',
							color: '#7B809A',
						}}
					>
						{message}
					</Typography>
				</div>
			</DialogContent>
			<div className="w-full h-[2px] bg-[#E9ECEF] mt-2 mb-6" />
			<DialogActions sx={{ padding: 0 }}>
				<Button
					sx={{
						color: '#343A40',
						fontWeight: 'bold',
						textTransform: 'none',
						'&:hover': {
							backgroundColor: 'transparent',
						},
					}}
					onClick={onClose}
				>
					{cancelButtonText || t('cancel')}
				</Button>
				<Button
					sx={{
						background: '#00AB89',
						fontWeight: 'bold',
						color: 'white',
						textTransform: 'none',
						'&:hover': {
							background: '#009B7B',
						},
					}}
					onClick={onConfirm}
					variant="contained"
				>
					{confirmButtonText || t('confirm')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmationModal;
